import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Dispatch} from "redux";
import {
    useGetFilledPrescriptionPrint,
    useSendIhioPrescriptionFilling
} from "../../../../../hook/request/ihioPrescriptionFilling";
import {
    IhioGetFilledPrescriptionPrintRequest, IhioPrescriptionAdmissionType,
    IhioSendPrescriptionFillingRequestType, IhioSendPrescriptionFillingResponseType, IhioWrittenPrescriptionItemType
} from "../../../../../types/ihioPrescriptionFilling";
import {toast} from "react-hot-toast";
import {TGIdNameData} from "../../../../../types/general";
import Modal from "../../../general/modal";
import {
    isHideModalDataSelector,
    isShowModalDataSelector,
    modalDataSelector,
    modalNameSelector
} from "../../../../../store/selector/general";
import {general} from "../../../../../store/action";
import {convertBase64ToFile, downloadFile} from "../../../../../utils/fileConvertor";
import ReadyToFulfilPrescriptionCard from "./readyToFulfilPrescriptionCard";
import Icon from "../../../general/icon";

type ModalInfoProps = {
    prescriptionAdmissionData?: IhioPrescriptionAdmissionType;
    itemsToFulfil?: Record<string, IhioWrittenPrescriptionItemType>;
}

type FulfilPrescriptionModalProps = {
    modalData: any;
    modalName: string;
    isShowModalData: boolean;
    handleHideModal: any;
    handleResetModal: any;
}

const FulfilPrescriptionModal = ({
    modalData,
    modalName,
    isShowModalData,
    handleHideModal,
    handleResetModal,
}: FulfilPrescriptionModalProps) => {

    const navigate = useNavigate();

    const [showState, setShowState] = useState(false);
    const [modalInfo, setModalInfo] = useState<ModalInfoProps>({});
    const [ihioSendPrescriptionFillingResponseData, setIhioSendPrescriptionFillingResponseData] = useState<IhioSendPrescriptionFillingResponseType>()

    const sendIhioPrescriptionFillingRequest = useSendIhioPrescriptionFilling();
    const getFilledPrescriptionPrintRequest = useGetFilledPrescriptionPrint()

    useEffect(() => {
        if(
            isShowModalData &&
            modalName === 'fulfilPrescriptionModal'
        ){
            setShowState(true);
            setModalInfo(modalData);
            handleResetModal();
        }
    }, [modalData, modalName])

    useEffect(() => {
        if(sendIhioPrescriptionFillingRequest?.isSuccess) {
            setIhioSendPrescriptionFillingResponseData(sendIhioPrescriptionFillingRequest?.data?.data?.result)
        }
    }, [sendIhioPrescriptionFillingRequest?.isSuccess]);

    useEffect(() => {
        if(ihioSendPrescriptionFillingResponseData?.messages?.infoMessage) {
            ihioSendPrescriptionFillingResponseData?.messages?.infoMessage?.map((message: any) => {
                toast(message)
            })
        }
    }, [ihioSendPrescriptionFillingResponseData?.messages?.infoMessage]);

    useEffect(() => {
        if(ihioSendPrescriptionFillingResponseData?.messages?.snackMessage) {
            ihioSendPrescriptionFillingResponseData?.messages?.snackMessage?.map((message: any) => {
                toast(message.text)
            })
        }
    }, [ihioSendPrescriptionFillingResponseData?.messages?.snackMessage]);

    useEffect(() => {
        if(ihioSendPrescriptionFillingResponseData?.checkCode) {
            const body: IhioGetFilledPrescriptionPrintRequest = {
                nationalCode: modalInfo?.prescriptionAdmissionData?.nationalCode || '',
                trackingCode: modalInfo?.prescriptionAdmissionData?.trackingCode || '',
                checkCode: ihioSendPrescriptionFillingResponseData?.checkCode
            }
            getFilledPrescriptionPrintRequest.mutate(body)
        }
    }, [ihioSendPrescriptionFillingResponseData?.checkCode]);

    useEffect(() => {
        if(getFilledPrescriptionPrintRequest.isSuccess && getFilledPrescriptionPrintRequest.data?.data?.result) {
            handleDownloadIhioPrintPrescription(getFilledPrescriptionPrintRequest?.data?.data?.result?.file, getFilledPrescriptionPrintRequest?.data?.data?.result?.type)
            navigate('/prescriptionFilling')
        }
    }, [getFilledPrescriptionPrintRequest?.data?.data?.result]);

    const handleSendPrescriptionFilling = () => {
        if(modalInfo?.itemsToFulfil)  {
            const otherItems = Object.values(modalInfo?.itemsToFulfil) // Convert object to an array
                .map((field: any) => field.checkCode) // Extract check codes
                .filter((checkCode: any) => checkCode); // Remove any undefined or null check codes

            const body: IhioSendPrescriptionFillingRequestType = {
                patientNationalCode: modalInfo?.prescriptionAdmissionData?.nationalCode || '',
                prescriptionTrackingCode: modalInfo?.prescriptionAdmissionData?.trackingCode || '',
                checkCodes: otherItems || []
            }
            sendIhioPrescriptionFillingRequest.mutate(body);
        }
    }

    const handleDownloadIhioPrintPrescription = (base64Data: any, type: TGIdNameData) => {
        const file = convertBase64ToFile(
            base64Data,
            `نسخه ${type?.name} - ${modalInfo?.prescriptionAdmissionData?.nationalCode} ${modalInfo?.prescriptionAdmissionData?.nationalCode} - ${modalInfo?.itemsToFulfil?.creationDate}`,
            'application/pdf'
        )
        downloadFile(file);
    };

    const handleSetShowModal = () => {
        setShowState(false);
        handleHideModal();
    }

    return (
        <Modal
            setShow={handleSetShowModal}
            showState={showState}
            noCloseBtn={true}
            className="w-1000 mw-100"
            bodyClassName="py-5 px-3 px-lg-5 pos-rel"
        >
            <div className='d-flex mb-4 fs-3 px-2'>
                <div className=" px-2 flex-fill align-content-center">
                    <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
                        ارائه خدمت
                    </h4>
                </div>
                <span className='text-red-hover align-content-center mt-2' onClick={() => handleSetShowModal()}>
                      <Icon name='close-square'/>
                    </span>
            </div>
            {modalInfo?.itemsToFulfil && Object.keys(modalInfo?.itemsToFulfil)?.map(UUID => {
                if (modalInfo?.itemsToFulfil && modalInfo?.itemsToFulfil[UUID]) {
                    return (
                        <ReadyToFulfilPrescriptionCard
                            key={UUID}
                            item={modalInfo?.itemsToFulfil[UUID]}
                        />
                    )
                }
            })}
            <div className="d-flex justify-content-center gap-2 mt-4 pt-2">
                <button
                    onClick={() => handleSetShowModal()}
                    className="btn btn-outline-gray flex-grow-1 py-2 mx-1"
                >
                    انصراف
                </button>
                <button
                    onClick={() => handleSendPrescriptionFilling()}
                    className="btn btn-primary flex-grow-1 py-2 mx-1"
                >
                    ارائه خدمت
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state: any) => ({
    modalData: modalDataSelector(state),
    modalName: modalNameSelector(state),
    isShowModalData: isShowModalDataSelector(state),
    isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleHideModal: () => dispatch(general.handleHideModal()),
    handleResetModal: () => dispatch(general.handleResetModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FulfilPrescriptionModal);
